const BaseView = require('../abstract-element-options');

module.exports = BaseView.extend({
  template: require('./template.hbs'),

  initialize: async function (options) {
    this.selection = options.selection;
    this.dictionary = _.chain(this.getRestrictions('dictionary'))
      .pluck('list')
      .flatten()
      .filter(Boolean)
      .value();

    const { resources, folders } = await this.getAllowedReplacements('Text');
    this.source = resources;
    this.folders = folders;
    BaseView.prototype.initialize.call(this, options);
  },

  fromFolderResourceToSource: function (resource) {
    return resource.data.default_content;
  },

  render: function () {
    const permissions = this.selection.permissions[0]?.basic || {};

    const permissionName = 'text_change_content';
    const globalPermissions = INKIVE.RestrictionsFacade.getAllDefaultPermissions();
    const canReplace = permissions[permissionName] ?? globalPermissions[permissionName];
    const source = this.dictionary.map(text => ({ source: text })).concat(this.source || []);

    if ((canReplace && (source.length > 0 || this.folders)) || this.colors.length) {
    // if (canReplace || this.colors.length) {
      this.$el.html(this.template());
      this.initReplacementPanel({
        folders: this.folders,
        assets: source,
        colors: this.colors?.length > 0 && [{ palette: [...this.colors] }]
      }, 'text');
    }
  },

  replaceItem: function (asset) {
    const id = INKIVE.DesignFacade.getSelectedElements()[0].id;

    if (!asset.source) {
      return;
    }

    if (asset.action !== 'color_replace') {
      INKIVE.DesignFacade.set({
        content: asset.source,
        text_content: asset.source,
        force_redraw: true
      });

      return;
    }

    const isTextEditing = INKIVE.EditorFacade.canvas.getMode() === 'textedit';
    if (isTextEditing) {
      const textDOM = INKIVE.DesignFacade.getSelectedElements()[0];
      const textarea = new INKIVE.Text.Textarea().setDOM(textDOM);

      if (!textarea) return;

      const range = INKIVE.EditorFacade.canvas.runExtensions('selectionRange', {});
      textarea.text.setPartialStyling(range.start, range.end, 'fill', asset.source);

      INKIVE.EditorFacade.canvas.runExtensions('renderTextArea', { textArea: textarea });
      INKIVE.DesignFacade.trigger('text.update');
    } else {
      INKIVE.DesignFacade.set(id, { color: asset.source });
    }
  }

});
